import Vue from 'vue';
import BoList from './bo-list';
import BoListItem from './bo-list-item';

Vue.component('bo-list', BoList);
Vue.component('bo-list-item', BoListItem);

export default BoList;



// WEBPACK FOOTER //
// ./scripts/bo-list/index.js